// Module
var code = "<svg width=\"36\" height=\"36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"18\" cy=\"18\" r=\"17.5\" stroke=\"#fff\"/><rect x=\"17\" y=\"10\" width=\"2\" height=\"16\" rx=\"1\" fill=\"#fff\"/><rect x=\"10\" y=\"17\" width=\"16\" height=\"2\" rx=\"1\" fill=\"#fff\"/></svg>";
// Exports
module.exports = code;